export default __webpack_public_path__ + "static/media/ISKO_CLASS-3_SYLLABUS.54e35398.pdf";